<template>
  <div class="workCodeInformationPackage table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      工單資訊
    </li>
    <b-table
      :items="workCodeInformationPackageItem"
      :fields="workCodeInformationPackageFields"
      class="text-center workCodeInformationPackage-table-detail"
    >
      <!-- <template #cell(code)="row">
        {{ row.item["code"].code }}
        <br />
        ({{ row.item["code"].org_code }})
      </template> -->
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "workCodeInformationPackage",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      workCodeInformationPackageFields:
        "workCodeInformationPackage/get_workCodeInformationPackageFields",
      workCodeInformationPackageItem:
        "workCodeInformationPackage/get_workCodeInformationPackageItem",
    }),
  },
};
</script>

<style lang="scss">
.workCodeInformationPackage-table-detail thead th {
  border-top: 1px solid;
}
.workCodeInformationPackage-table-detail th,
.workCodeInformationPackage-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}
.workCodeInformationPackage-table-detail th:first-child,
.workCodeInformationPackage-table-detail td:first-child {
  border-left: 1px solid;
}
.workCodeInformationPackage-table-detail {
  margin-bottom: 0px;
}
.workCodeInformationPackage-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/workCodeInformationPackage.vue